import { RestaurantTableIcon, Store01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useFormikContext } from "formik";
import { Chip, Stack } from "@mui/material";
import { OnboardingFormValues } from "../Onboarding";

const OrganizationTypeStep = () => {
    const { values, setFieldValue } = useFormikContext<OnboardingFormValues>();

    const handleChange = (value: string) => {
        setFieldValue('industry', value);
    }

    return (
        <Stack spacing={2}>
            <Chip
                icon={<HugeiconsIcon icon={RestaurantTableIcon} />}
                label="Restaurante"
                color="secondary"
                variant={values.industry === 'restaurant' ? 'filled' : 'outlined'}
                onClick={() => handleChange('restaurant')}
            />
            <Chip
                icon={<HugeiconsIcon icon={Store01Icon} />}
                label="Otro (Tienda o Comercio)"
                color="secondary"
                variant={values.industry === 'other' ? 'filled' : 'outlined'}
                onClick={() => handleChange('other')}
            />
        </Stack>
    );
};

export default OrganizationTypeStep;
